import React, { useState, useEffect } from "react";
import { styled } from "../../stitches.config";
import Cookies from "cookies-js"

import CircleButton from '../CircleButton'

import { bridVote } from './bridVote'

const BridCompareWithLink = props => {
    const { article, secondArticleID, thirdArticleID, voted, uID, hasCookie } = props;
    const [percentage, setPercentage] = useState(null);
    const isMobile = window.innerWidth < 996;
    const imageHeight = (props.imageHeight > 0 ? props.imageHeight : 306);
    const articlesGroup = [article.articleID, secondArticleID, thirdArticleID]

    useEffect(() => {
        const fetchVotes = () => {
            const fd = new FormData();

            fd.set("articlesGroup", JSON.stringify(articlesGroup));

            fetch(`${window.API_HOST}/pwa-brid-vote/`, {
                method: 'POST',
                body: fd
            })
                .then(response => {
                    return response.ok
                        ? response.json()
                        : Promise.reject(response.status);
                })
                .then(res => {
                    // console.log(res);
                    setPercentage(res.data.articlesAverage)
                })
                .catch(err => console.log(err))
        }

        fetchVotes()
    }, [])

    // useEffect(() => {
    //     console.log(percentage)
    // }, [percentage])

    var imgUrl = article.picture.img;
    imgUrl = imgUrl.replace("780,0,0,0", "0," + imageHeight + ",0,0");
    return (
        <Container>
            <Article>
                <ArticleCard>
                    <div className="overlay" />
                    <img src={imgUrl} />
                    <h3>{article.title}</h3>
                    <Voted>{percentage?.[article.articleID] ? percentage?.[article.articleID] : "0"}% {isMobile || "oddanych "}głosów</Voted>
                    {
                        hasCookie
                            ? <Thankyou>{voted == article.articleID ? 'Dziękujemy!' : ''}</Thankyou>
                            : <>
                                {voted === article.articleID ?
                                    <Thankyou>Dziękujemy!</Thankyou>
                                    :
                                    <CircleButton
                                        disabled={!!(voted !== article.articleID ^ voted === null)}
                                        onClick={() => {
                                            bridVote(article.articleID, articlesGroup)
                                            props.setVoted(article.articleID)
                                            if (uID) Cookies.set('_brid', `${props.uID}.${article.articleID}`, { expires: 86400 })
                                        }}>
                                        Oddaj głos
                                    </CircleButton>}
                            </>
                    }
                </ArticleCard>
                <AboutWrapper>
                    <b>O projekcie</b>
                    <p>{article.label}</p>
                    <a href={article.link}><CircleButton> Czytaj więcej</CircleButton></a>
                </AboutWrapper>
                {/* {isMobile && <p>{percentage?.[article.articleID]}% oddanych głosów</p>} */}
            </Article>
        </Container>
    );
}

const Container = styled("div", {
    marginLeft: "20px",
    marginRight: "20px",
    "@media (min-width: 992px)": {
        marginLeft: "0",
        marginRight: "0"
    }
});

const Thankyou = styled("span", {
    display: "block",
    position: "absolute",
    margin: "10px",
    fontSize: "19px",
    zIndex: 3,
    right: "35px",
    bottom: "55px",
    color: "$primary",
    "@media (min-width: 992px)": {
        bottom: "25px"
    }
});

const Article = styled("div", {
    display: "flex",
    flexDirection: "column",
    minHeight: "350px",
    overflow: "hidden",
    marginBottom: "40px",
    "@media (min-width: 992px)": {
        flexDirection: "row",
        marginBottom: "20px",
        minHeight: "276px",
        maxHeight: "300px"
    }
});

const ArticleCard = styled("div", {
    position: "relative",
    overflow: "hidden",
    minHeight: "306px",
    "& > *": {
        position: "absolute"
    },
    ".overlay": {
        zIndex: 2,
        left: "0",
        top: "0",
        right: "0",
        bottom: "0",
        backgroundImage:
            "linear-gradient(to top, #000000, rgba(80, 73, 70, 0.26) 57%, rgba(44, 44, 44, 0))"
    },
    img: {
        position: "absolute",
        objectFit: "cover",
        width: "100%",
        minHeight: "100%",
        maxHeight: "100%"
    },
    h3: {
        position: "absolute",
        width: "91%",
        marginLeft: "15px",
        zIndex: 3,
        bottom: "100px",
        textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
        fontFamily: "$grotesk",
        fontSize: "24px",
        fontWeight: 500,
        color: "#fafafa"
    },
    button: {
        position: "absolute",
        right: "-20px",
        bottom: "46px",
        zIndex: 3,
        fontSize: "14px",
        width: "10.5em !important",
        ".circle": {
            background: "transparent !important"
        },
        ".icon": {
            "&:before": {
                borderColor: "#fff !important"
            }
        },
        ".button-text": {
            color: "#fff !important",
            margin: "0 0 0 2.65em !important"
        },
        "&:hover": {
            ".icon": {
                "&.arrow": {
                    background: "#fff !important",
                    "&:before": {
                        borderColor: "#fff !important",
                        transition: "border-color 300ms !important"
                    }
                }
            },
            ".circle": {
                backgroundColor: "$primary !important"
            }
        }
    },
    "@media (min-width: 992px)": {
        minWidth: "470px",
        "h3": {
            bottom: "80px",
            marginLeft: "20px"
        },
        "button": {
            right: "0",
            bottom: "13px"
        }
    }
});

const AboutWrapper = styled("div", {
    padding: "27px 38px 27px 30px",
    borderRadius: "16px",
    boxShadow: "0 1px 8px 0 rgba(110, 110, 110, 0.1)",
    border: "solid 1px",
    bordercolor: "$primary",
    backgroundColor: "#ffffff",
    marginTop: "-27px",
    minWidth: "240px",
    zIndex: 4,
    "p": {
        fontSize: "17px",
        fontWeight: 300,
        lineHeight: 1.29,
        letterSpacing: "-0.32px",
        color: "#272424",
        marginBottom: "30px"
    },
    "a": {
        color: "#ffffff",
        cursor: "pointer"
    },
    "button": {
        margin: "10px 0px",
        fontSize: "14px",
        ".button-text": {
            margin: "0 0 0 40px !important"
        }
    },
    "b": {
        fontFamily: "$grotesk",
        fontSize: "16px",
        fontWeight: 900,
        lineHeight: 1.25,
        letterSpacing: "0.01px",
        color: "#272424"
    },
    "@media (min-width: 992px)": {
        marginLeft: "30px",
        marginTop: "0",
        padding: "27px 38px 47px 30px",
        "p": {
            overflowY: "auto",
            maxHeight: "150px",
            marginBottom: "0px"
        },
        "a": {
            position: "absolute",
            bottom: "25px",
            margin: "0"
        }
    }
});
const Voted = styled("span", {
    zIndex: 3,
    maxWidth: "50%",
    display: "block",
    position: "absolute",
    left: "20px",
    bottom: "65px",
    fontSize: "18px",
    fontWeight: 500,
    color: "#fafafa",
    "@media (min-width: 992px)": {
        bottom: "35px"
    }
});

export default BridCompareWithLink

//    background-color: ${props => props.theme.mainColor};
//      width: 200px;
//    padding: 10px 20px;